export default __webpack_public_path__ + "static/media/placeholder3.73657866.png";